import { createReducer, createActions } from 'reduxsauce'

// Action Types & Creators
export const { Types, Creators } = createActions({
    sustainabilityFilterClean: [],
    setSustainabilityFilter: [],
});

// Handlers
const INITIAL_STATE = {
  filter: {
    fornecedor: '',
    numeroPedido: '',
    statusAuditoria: '',
    dataCriacaoInicial: '',
    dataCriacaoFinal: '',
    dataPedidoInicial: '',
    dataPedidoFinal: '',
    orderBy: "pedido asc"
  }
};

function sustainabilityFilterClean(state = INITIAL_STATE, action) {
  return { ...INITIAL_STATE }
}

function setSustainabilityFilter(state = INITIAL_STATE, action) {
  return { 
    ...state,
    filter: action.filter,
  }
}

// Reducer
export default createReducer(INITIAL_STATE, {
  DECLARATION_FILTER_CLEAN: sustainabilityFilterClean,
  [Types.SET_SUSTAINABILITY_FILTER]: setSustainabilityFilter,
});
